import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import StrippingService from "../services/strippingService";

// Get Stripping Process List Start

const getStrippingProcessList = {
  getStrippingProcessListLoading: true,
  getStrippingProcessListData: null,
  getStrippingProcessListError: null,
};

const getStrippingProcessListData = createAsyncThunk(
  "stripping/list",
  async (payload) => {
    return await StrippingService.getStrippingProcessListApi(payload);
  },
);

const getStrippingProcessListReducer = createSlice({
  name: "getStrippingProcessList",
  initialState: getStrippingProcessList,
  extraReducers: (builder) => {
    builder.addCase(getStrippingProcessListData.pending, (state) => {
      state.getStrippingProcessListLoading = true;
    });
    builder.addCase(getStrippingProcessListData.fulfilled, (state, action) => {
      state.getStrippingProcessListLoading = false;
      state.getStrippingProcessListData = action.payload;
      state.getStrippingProcessListError = "";
    });
    builder.addCase(getStrippingProcessListData.rejected, (state, action) => {
      state.getStrippingProcessListLoading = false;
      state.getStrippingProcessListData = null;
      state.getStrippingProcessListError = action.error.message;
    });
  },
});

export const GetStrippingProcessListReducer =
  getStrippingProcessListReducer.reducer;
export const GetStrippingProcessListData = getStrippingProcessListData;

// Get Stripping Process List End

// Update Stripping Process By Id Start

const updateStrippingProcessByIdState = {
  updateStrippingProcessByIdLoading: false,
  updateStrippingProcessById: null,
  updateStrippingProcessByIdError: null,
};

const updateStrippingProcessById = createAsyncThunk(
  "stripping/updateProcessById",
  async (payload) => {
    return await StrippingService.updateStrippingProcessByIdApi(payload);
  },
);

const updateStrippingProcessByIdReducer = createSlice({
  name: "updateStrippingProcessById",
  initialState: updateStrippingProcessByIdState,
  extraReducers: (builder) => {
    builder.addCase(updateStrippingProcessById.pending, (state) => {
      state.updateStrippingProcessByIdLoading = true;
    });
    builder.addCase(updateStrippingProcessById.fulfilled, (state, action) => {
      state.updateStrippingProcessByIdLoading = false;
      state.updateStrippingProcessById = action.payload;
      state.updateStrippingProcessByIdError = "";
    });
    builder.addCase(updateStrippingProcessById.rejected, (state, action) => {
      state.updateStrippingProcessByIdLoading = false;
      state.updateStrippingProcessById = null;
      state.updateStrippingProcessByIdError = action.error.message;
    });
  },
});

export const UpdateStrippingProcessByIdReducer =
  updateStrippingProcessByIdReducer.reducer;
export const UpdateStrippingProcessById = updateStrippingProcessById;

// Update Stripping Process By Id End

// Add Stripping Process End

const addNewStrippingProcessState = {
  addNewStrippingProcessLoading: false,
  addNewStrippingProcessData: null,
  addNewStrippingProcessError: null,
};

const addNewStrippingData = createAsyncThunk("stripping/add", async (payload) => {
  return await StrippingService.addNewStrippingApi(payload);
});

const addNewStrippingReducer = createSlice({
  name: "addNewStrippingProcess",
  initialState: addNewStrippingProcessState,
  extraReducers: (builder) => {
    builder.addCase(addNewStrippingData.pending, (state) => {
      state.addNewStrippingProcessLoading = true;
    });
    builder.addCase(addNewStrippingData.fulfilled, (state, action) => {
      state.addNewStrippingProcessLoading = false;
      state.addNewStrippingProcessData = action.payload;
      state.addNewStrippingProcessError = "";
    });
    builder.addCase(addNewStrippingData.rejected, (state, action) => {
      state.addNewStrippingProcessLoading = false;
      state.addNewStrippingProcessData = null;
      state.addNewStrippingProcessError = action.error.message;
    });
  },
});

export const AddNewStrippingReducer = addNewStrippingReducer.reducer;
export const AddNewStrippingProcessData = addNewStrippingData;

// Add Stripping Process End

// Get Stripping Process By Id Start

const getStrippingProcessByIdState = {
  getStrippingProcessByIdLoading: true,
  getStrippingProcessByIdData: null,
  getStrippingProcessByIdError: null,
};

const getStrippingProcessDataById = createAsyncThunk(
  "stripping/processById",
  async (processId) => {
    return await StrippingService.getStrippingProcessByIdApi(processId);
  },
);

const getStrippingProcessByIdReducer = createSlice({
  name: "getStrippingProcessById",
  initialState: getStrippingProcessByIdState,
  extraReducers: (builder) => {
    builder.addCase(getStrippingProcessDataById.pending, (state) => {
      state.getStrippingProcessByIdLoading = true;
    });
    builder.addCase(getStrippingProcessDataById.fulfilled, (state, action) => {
      state.getStrippingProcessByIdLoading = false;
      state.getStrippingProcessByIdData = action.payload;
      state.getStrippingProcessByIdError = "";
    });
    builder.addCase(getStrippingProcessDataById.rejected, (state, action) => {
      state.getStrippingProcessByIdLoading = false;
      state.getStrippingProcessByIdData = null;
      state.getStrippingProcessByIdError = action.error.message;
    });
  },
});

export const GetStrippingProcessByIdReducer =
  getStrippingProcessByIdReducer.reducer;
export const GetStrippingProcessByIdData = getStrippingProcessDataById;

// Get Stripping Process By Id End

// Get Stripping Process Data List Start

const getStrippingProcessData = {
  getStrippingProcessDataLoading: true,
  getStrippingProcessDataData: null,
  getStrippingProcessDataError: null,
};

const getStrippingProcessDataData = createAsyncThunk(
  "stripping/processList",
  async (payload) => {
    return await StrippingService.getStrippingProcessDataApi(payload);
  },
);

const getStrippingProcessDataReducer = createSlice({
  name: "getStrippingProcessData",
  initialState: getStrippingProcessData,
  extraReducers: (builder) => {
    builder.addCase(getStrippingProcessDataData.pending, (state) => {
      state.getStrippingProcessDataLoading = true;
    });
    builder.addCase(getStrippingProcessDataData.fulfilled, (state, action) => {
      state.getStrippingProcessDataLoading = false;
      state.getStrippingProcessDataData = action.payload;
      state.getStrippingProcessDataError = "";
    });
    builder.addCase(getStrippingProcessDataData.rejected, (state, action) => {
      state.getStrippingProcessDataLoading = false;
      state.getStrippingProcessDataData = null;
      state.getStrippingProcessDataError = action.error.message;
    });
  },
});

export const GetStrippingProcessDataReducer =
  getStrippingProcessDataReducer.reducer;
export const GetStrippingProcessDataData = getStrippingProcessDataData;

// Get Stripping Process Data List End

// Send To Spirit Process Start

const sendToStrippingProcessState = {
  sendToStrippingProcessLoading: false,
  sendToStrippingProcess: null,
  sendToStrippingProcessError: null,
};

const sendToStrippingProcess = createAsyncThunk(
  "stripping/sendToStrippingProcess",
  async (payload) => {
    return await StrippingService.sendToStrippingProcessApi(payload);
  },
);

const sendToStrippingProcessReducer = createSlice({
  name: "sendToStrippingProcess",
  initialState: sendToStrippingProcessState,
  extraReducers: (builder) => {
    builder.addCase(sendToStrippingProcess.pending, (state) => {
      state.sendToStrippingProcessLoading = true;
    });
    builder.addCase(sendToStrippingProcess.fulfilled, (state, action) => {
      state.sendToStrippingProcessLoading = false;
      state.sendToStrippingProcess = action.payload;
      state.sendToStrippingProcessError = "";
    });
    builder.addCase(sendToStrippingProcess.rejected, (state, action) => {
      state.sendToStrippingProcessLoading = false;
      state.sendToStrippingProcess = null;
      state.sendToStrippingProcessError = action.error.message;
    });
  },
});

export const SendToStrippingProcessReducer =
  sendToStrippingProcessReducer.reducer;
export const SendToStrippingProcess = sendToStrippingProcess;
// Send To Spirit Process End

// Add Stripping Process By Id Start

const addStrippingProcessDataState = {
  addStrippingProcessDataLoading: false,
  addStrippingProcessData: null,
  addStrippingProcessDataError: null,
};

const addStrippingProcessData = createAsyncThunk(
  "stripping/addProcessData",
  async (payload) => {
    return await StrippingService.addStrippingProcessDataApi(payload);
  },
);

const addStrippingProcessDataReducer = createSlice({
  name: "addStrippingProcessData",
  initialState: addStrippingProcessDataState,
  extraReducers: (builder) => {
    builder.addCase(addStrippingProcessData.pending, (state) => {
      state.addStrippingProcessDataLoading = true;
    });
    builder.addCase(addStrippingProcessData.fulfilled, (state, action) => {
      state.addStrippingProcessDataLoading = false;
      state.addStrippingProcessData = action.payload;
      state.addStrippingProcessDataError = "";
    });
    builder.addCase(addStrippingProcessData.rejected, (state, action) => {
      state.addStrippingProcessDataLoading = false;
      state.addStrippingProcessData = null;
      state.addStrippingProcessDataError = action.error.message;
    });
  },
});

export const AddStrippingProcessDataByIdReducer =
  addStrippingProcessDataReducer.reducer;
export const AddStrippingProcessDataById = addStrippingProcessData;

// Add Stripping Process By Id End

// Update Stripping Process By Id Start

const updateStrippingProcessDataByIdState = {
  updateStrippingProcessDataByIdLoading: false,
  updateStrippingProcessDataById: null,
  updateStrippingProcessDataByIdError: null,
};

const updateStrippingProcessDataById = createAsyncThunk(
  "stripping/updateProcessDataById",
  async (payload) => {
    return await StrippingService.updateStrippingProcessDataByIdApi(payload);
  },
);

const updateStrippingProcessDataByIdReducer = createSlice({
  name: "updateStrippingProcessDataById",
  initialState: updateStrippingProcessDataByIdState,
  extraReducers: (builder) => {
    builder.addCase(updateStrippingProcessDataById.pending, (state) => {
      state.updateStrippingProcessDataByIdLoading = true;
    });
    builder.addCase(
      updateStrippingProcessDataById.fulfilled,
      (state, action) => {
        state.updateStrippingProcessDataByIdLoading = false;
        state.updateStrippingProcessDataById = action.payload;
        state.updateStrippingProcessDataByIdError = "";
      },
    );
    builder.addCase(
      updateStrippingProcessDataById.rejected,
      (state, action) => {
        state.updateStrippingProcessDataByIdLoading = false;
        state.updateStrippingProcessDataById = null;
        state.updateStrippingProcessDataByIdError = action.error.message;
      },
    );
  },
});

export const UpdateStrippingProcessDataByIdReducer =
  updateStrippingProcessDataByIdReducer.reducer;
export const UpdateStrippingProcessDataById = updateStrippingProcessDataById;

// Update Stripping Process By Id End

// Get Stripping Process By Id Start

const getStrippingProcessDataByIdState = {
  getStrippingProcessDataByIdLoading: false,
  getStrippingProcessDataById: null,
  getStrippingProcessDataByIdError: null,
};

const getProcessDataById = createAsyncThunk(
  "stripping/getProcessDataById",
  async (strippingProcessDataId) => {
    return await StrippingService.getProcessDataById(strippingProcessDataId);
  },
);

const getStrippingProcessDataByIdReducer = createSlice({
  name: "getStrippingProcessDataById",
  initialState: getStrippingProcessDataByIdState,
  extraReducers: (builder) => {
    builder.addCase(getProcessDataById.pending, (state) => {
      state.getStrippingProcessDataByIdLoading = true;
    });
    builder.addCase(getProcessDataById.fulfilled, (state, action) => {
      state.getStrippingProcessDataByIdLoading = false;
      state.getStrippingProcessDataById = action.payload;
      state.getStrippingProcessDataByIdError = "";
    });
    builder.addCase(getProcessDataById.rejected, (state, action) => {
      state.getStrippingProcessDataByIdLoading = false;
      state.getStrippingProcessDataById = null;
      state.getStrippingProcessDataByIdError = action.error.message;
    });
  },
});

export const GetStrippingProcessDataByIdReducer =
  getStrippingProcessDataByIdReducer.reducer;
export const GetProcessDataById = getProcessDataById;

// Get Stripping Process By Id End

// Add Waste Water Start
const defaultAddWasteWaterState = {
  addWasteWaterLoading: false,
  addWasteWaterData: null,
  addWasteWaterError: null,
};

const addWasteWaterData = createAsyncThunk(
  "wastewater/add",
  async (payload) => {
    return await StrippingService.addWasteWaterData(payload);
  },
);

const addWasteWaterReducer = createSlice({
  name: "addWasteWater",
  initialState: defaultAddWasteWaterState,
  extraReducers: (builder) => {
    builder.addCase(addWasteWaterData.pending, (state) => {
      state.addWasteWaterLoading = true;
    });
    builder.addCase(addWasteWaterData.fulfilled, (state, action) => {
      state.addWasteWaterLoading = false;
      state.addWasteWaterData = action.payload;
      state.addWasteWaterError = "";
    });
    builder.addCase(addWasteWaterData.rejected, (state, action) => {
      state.addWasteWaterLoading = false;
      state.addWasteWaterData = null;
      state.addWasteWaterError = action.error.message;
    });
  },
});

export const AddWasteWaterReducer = addWasteWaterReducer.reducer;
export const AddWasteWaterData = addWasteWaterData;
// Add Waste Water End

// Update Waste Water Start
const updateWasteWaterState = {
  updateWasteWaterLoading: false,
  updateWasteWaterData: null,
  updateWasteWaterError: null,
};

const updateWasteWater = createAsyncThunk(
  "wastewater/update",
  async (payload) => {
    return await StrippingService.updateWasteWater(payload);
  },
);

const updateWasteWaterReducer = createSlice({
  name: "updateWasteWaterReducer",
  initialState: updateWasteWaterState,
  extraReducers: (builder) => {
    builder.addCase(updateWasteWater.pending, (state) => {
      state.updateWasteWaterLoading = true;
    });
    builder.addCase(updateWasteWater.fulfilled, (state, action) => {
      state.updateWasteWaterLoading = false;
      state.updateWasteWaterData = action.payload;
      state.updateWasteWaterError = "";
    });
    builder.addCase(updateWasteWater.rejected, (state, action) => {
      state.updateWasteWaterLoading = false;
      state.updateWasteWaterData = null;
      state.updateWasteWaterError = action.error.message;
    });
  },
});

export const UpdateWasteWaterReducer = updateWasteWaterReducer.reducer;
export const UpdateWasteWater = updateWasteWater;
//Update Waste Water End

// Get Waste Water Data List Start
const defaultWasteWaterListData = {
  getWasteWaterListLoading: false,
  getWasteWaterListData: null,
  getWasteWaterListError: null,
};

const fetchWasteWaterList = createAsyncThunk(
  "wastewater/wastewaterList",
  async (payload) => {
    return await StrippingService.getWasteWaterList(payload);
  },
);

const getWasteWaterListReducer = createSlice({
  name: "getWasteWaterListData",
  initialState: defaultWasteWaterListData,
  extraReducers: (builder) => {
    builder.addCase(fetchWasteWaterList.pending, (state) => {
      state.getWasteWaterListLoading = true;
    });
    builder.addCase(fetchWasteWaterList.fulfilled, (state, action) => {
      state.getWasteWaterListLoading = false;
      state.getWasteWaterListData = action.payload;
      state.getWasteWaterListError = "";
    });
    builder.addCase(fetchWasteWaterList.rejected, (state, action) => {
      state.getWasteWaterListLoading = false;
      state.getWasteWaterListData = null;
      state.getWasteWaterListError = action.error.message;
    });
  },
});

export const GetWasteWaterListReducer = getWasteWaterListReducer.reducer;
export const FetchWasteWaterList = fetchWasteWaterList;
// Get Waste Water Data List End

// Add Sub Log Start
const defaultSubLogState = {
  addSubLogLoading: false,
  addSubLogData: null,
  addSubLogError: null,
};

const addSubLogData = createAsyncThunk("sublog/add", async (payload) => {
  return await StrippingService.addStrippingSubLogData(payload);
});

const addSubLogReducer = createSlice({
  name: "addSubLog",
  initialState: defaultSubLogState,
  extraReducers: (builder) => {
    builder.addCase(addSubLogData.pending, (state) => {
      state.addSubLogLoading = true;
    });
    builder.addCase(addSubLogData.fulfilled, (state, action) => {
      state.addSubLogLoading = false;
      state.addSubLogData = action.payload;
      state.addSubLogError = "";
    });
    builder.addCase(addSubLogData.rejected, (state, action) => {
      state.addSubLogLoading = false;
      state.addSubLogData = null;
      state.addSubLogError = action.error.message;
    });
  },
});

export const AddSubLogReducer = addSubLogReducer.reducer;
export const AddSubLogData = addSubLogData;
// Add Sub Log End

// Update Sub Log Start
const updateSubLogState = {
  updateSubLogLoading: false,
  updateSubLogData: null,
  updateSubLogError: null,
};

const updateSubLog = createAsyncThunk("subLog/update", async (payload) => {
  return await StrippingService.updateStrippingSubLog(payload);
});

const updateSubLogReducer = createSlice({
  name: "updateSubLogReducer",
  initialState: updateSubLogState,
  extraReducers: (builder) => {
    builder.addCase(updateSubLog.pending, (state) => {
      state.updateSubLogLoading = true;
    });
    builder.addCase(updateSubLog.fulfilled, (state, action) => {
      state.updateSubLogLoading = false;
      state.updateSubLogData = action.payload;
      state.updateSubLogError = "";
    });
    builder.addCase(updateSubLog.rejected, (state, action) => {
      state.updateSubLogLoading = false;
      state.updateSubLogData = null;
      state.updateSubLogError = action.error.message;
    });
  },
});

export const UpdateSubLogReducer = updateSubLogReducer.reducer;
export const UpdateSubLog = updateSubLog;
//Update Sub Log End

// Get Sub Log Data List Start
const defaultSubLogListData = {
  getSubLogListLoading: false,
  getSubLogListData: null,
  getSubLogListError: null,
};

const fetchSubLogList = createAsyncThunk(
  "sublog/subLogList",
  async (payload) => {
    return await StrippingService.getStrippingSubLogList(payload);
  },
);

const getSubLogListReducer = createSlice({
  name: "getSubLogListData",
  initialState: defaultSubLogListData,
  extraReducers: (builder) => {
    builder.addCase(fetchSubLogList.pending, (state) => {
      state.getSubLogListLoading = true;
    });
    builder.addCase(fetchSubLogList.fulfilled, (state, action) => {
      state.getSubLogListLoading = false;
      state.getSubLogListData = action.payload;
      state.getSubLogListError = "";
    });
    builder.addCase(fetchSubLogList.rejected, (state, action) => {
      state.getSubLogListLoading = false;
      state.getSubLogListData = null;
      state.getSubLogListError = action.error.message;
    });
  },
});

export const GetSubLogListReducer = getSubLogListReducer.reducer;
export const FetchSubLogList = fetchSubLogList;
// Get Sub Log Data List End

// Delete Sub Log Start
const deleteSubLogState = {
  deleteSubLogLoading: false,
  deleteSubLogData: null,
  deleteSubLogError: null,
};

const deleteSubLog = createAsyncThunk("subLog/delete", async (payload) => {
  return await StrippingService.deleteStrippingSubLog(payload);
});

const deleteSubLogReducer = createSlice({
  name: "deleteSubLogReducer",
  initialState: deleteSubLogState,
  extraReducers: (builder) => {
    builder.addCase(updateSubLog.pending, (state) => {
      state.deleteSubLogLoading = true;
    });
    builder.addCase(updateSubLog.fulfilled, (state, action) => {
      state.deleteSubLogLoading = false;
      state.deleteSubLogData = action.payload;
      state.deleteSubLogError = "";
    });
    builder.addCase(updateSubLog.rejected, (state, action) => {
      state.deleteSubLogLoading = false;
      state.deleteSubLogData = null;
      state.deleteSubLogError = action.error.message;
    });
  },
});

export const DeleteSubLogReducer = deleteSubLogReducer.reducer;
export const DeleteSubLog = deleteSubLog;
//Delete Sub Log End
